import { useCallback, useRef, useState } from "react"
import type { CompetitorCreativeCardModel } from "../lib/drilldown-card.types"

const CACHE_SIZE = 5

function preloadCreativeMedia(model: CompetitorCreativeCardModel): void {
  const urls = model.carouselSlides?.length
    ? model.carouselSlides.flatMap((s) => [s.thumbnailUrl, s.type === "image" ? s.assetUrl : ""]).filter(Boolean)
    : [model.thumbnailUrl, model.isVideo ? "" : model.assetUrl].filter(Boolean)

  for (const url of urls) {
    const img = new Image()
    img.src = url
  }
}

export function useDrilldownCreativeCache() {
  const cacheRef = useRef<Map<string, CompetitorCreativeCardModel>>(new Map())
  const [, bump] = useState(0)

  const put = useCallback((model: CompetitorCreativeCardModel) => {
    const next = new Map(cacheRef.current)
    next.delete(model.id)
    next.set(model.id, model)
    while (next.size > CACHE_SIZE) {
      const oldest = next.keys().next().value
      if (oldest) next.delete(oldest)
    }
    cacheRef.current = next
    preloadCreativeMedia(model)
    bump((v) => v + 1)
  }, [])

  const get = useCallback((id: string) => cacheRef.current.get(id), [])

  return { put, get }
}
